import React, { useEffect } from 'react';
import { Form, Input, Spin } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import useApi from '../hooks/useApi';
import useRedirecionamentoAoLogin from '../hooks/useRedirecionamentoAoLogin';
import { Content } from 'antd/es/layout/layout';
import Footer from '../componentes/Footer';
import fundoAlfama from '../imagens/fundo-alfama2.png';

const PaginaLogin = () => {
    localStorage.removeItem('token');
    const [form] = Form.useForm();

    useEffect(() => {
        document.title = 'Vision | Alfama Foods';
    }, []);

    const { loading, callApi } = useApi('https://vision.alfama.com/api/auth', {
        method: 'POST',
        successMessage: 'Login realizado com sucesso!',
        errorMessage: 'Erro ao fazer login. Tente novamente.'
    });

    const { redirecionarAposLogin } = useRedirecionamentoAoLogin();

    const onFinish = async (values) => {
        try {
            const response = await callApi({
                username: values.username,
                password: values.password,
            });

            if (response.token) {
                localStorage.setItem('token', response.token);
                localStorage.setItem('is_primeiro_login', response.is_primeiro_login);
                localStorage.setItem('login_method', response.login_method);
                redirecionarAposLogin();
            } else {
                throw new Error('Token não recebido do servidor');
            }
        } catch (error) {
            form.setFields([{ name: 'password', value: '' }]);
        }
    };

    return (
        <div
            className="min-h-screen flex flex-col bg-cover bg-center"
            style={{ backgroundImage: `url(${fundoAlfama})` }}
        >
            <Content className="flex flex-1 justify-center items-center p-5">
                <div className="w-[400px] p-8 bg-white/95 rounded-2xl shadow-xl backdrop-blur-md border border-white/20">
                    {/* Logo + Título */}
                    <div className="mb-7">
                        <div className="flex justify-center mb-4">
                            <img
                                src="/logo_login.png"
                                alt="Vision Logo"
                                className="w-56 object-contain"
                            />
                        </div>
                        <h2 className="text-center text-[25px] font-semibold text-blue-900 tracking-tight m-0">
                            Bem-vindo
                        </h2>
                    </div>

                    {/* Formulário */}
                    <Form
                        form={form}
                        name="login"
                        onFinish={onFinish}
                        autoComplete="off"
                        layout="vertical"
                    >
                        <Form.Item
                            name="username"
                            rules={[{ required: true, message: 'Insira seu usuário!' }]}
                            className="mb-4"
                        >
                            <Input
                                prefix={<UserOutlined className="text-blue-900" />}
                                placeholder="Nome de usuário"
                                size="large"
                                className="h-11 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 transition"
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: 'Insira sua senha!' }]}
                            className="mb-6"
                        >
                            <Input.Password
                                prefix={<LockOutlined className="text-blue-900" />}
                                placeholder="Senha"
                                size="large"
                                className="h-11 rounded-lg border border-gray-300 focus:border-blue-900 focus:ring-2 focus:ring-blue-900/20 transition"
                            />
                        </Form.Item>

                        <Form.Item className="mb-0">
                            <button
                                type="submit"
                                disabled={loading}
                                className={`w-full h-11 rounded-lg font-medium text-white transition-all shadow-md ${
                                    loading
                                        ? "bg-blue-300 cursor-not-allowed"
                                        : "bg-blue-900 hover:bg-blue-800 hover:-translate-y-0.5 hover:shadow-lg"
                                }`}
                            >
                                {loading ? (
                                    <>
                                        <Spin size="small" className="mr-2" /> Conectando...
                                    </>
                                ) : (
                                    'Conectar'
                                )}
                            </button>
                        </Form.Item>
                    </Form>
                </div>
            </Content>
            <Footer whiteText={true} />
        </div>
    );
};

export default PaginaLogin;
